import { render, staticRenderFns } from "./SilverCrown.vue?vue&type=template&id=abb7fba0"
import script from "./SilverCrown.vue?vue&type=script&lang=js"
export * from "./SilverCrown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports